import preloaded from '../src/preloaded.js';
import Feed from '../src/feed/Feed.js';
import mountFeed from '../src/feed/mountFeed.js';
const target = document.getElementById('feedContainer');
mountFeed(target, Feed, preloaded.feed_url);
